import { Directive, input, model } from "@angular/core";
import { SafeUrl } from "@angular/platform-browser";

@Directive({
    selector: "img[fallbackSrc]",
    host: {
        '(error)': 'updateUrl()',
        '[src]': 'src()'
    }
})
export class ImageFallbackSrcDirective {
    src = model<SafeUrl>();
    fallbackSrc = input.required<string>();

    updateUrl() {
        this.src.set(this.fallbackSrc());
    }
}
